import { TemplateType } from "hoxton-shared/enums/masterTemplate";

import type { ConstructedDeliverable } from "@/types/types";
import type { PlainlyLayerManagement } from "@/utils/CreativeIntelligenceApi/plainly";

import type { RequestRenderInput } from "./ae";
import computedValuesToComputedOverwrites from "./computedValuesToComputedOverwrites";

export default function computeAfterEffectsLayers(deliverables: ConstructedDeliverable[]) {
    const inputs = deliverables.reduce<RequestRenderInput[]>((acc, deliverable) => {
        if (deliverable.masterTemplate.adType !== TemplateType.AE) {
            return acc;
        }

        const computedOverwrites = computedValuesToComputedOverwrites(deliverable.computedValues);
        computedOverwrites.forEach(computedOverwrite => {
            const settings = computedOverwrite.settings;

            if (!settings) {
                return;
            }

            const layerManagement = {
                ...(settings.fontSize ? { fontSize: settings.fontSize } : {}),
                ...(settings.font ? { font: settings.font } : {})
            };

            if (layerManagement.fontSize || layerManagement.font) {
                computedOverwrite.layerManagement = layerManagement as PlainlyLayerManagement;
            }
        });

        acc.push({
            reportingLabel: deliverable.reportingLabel,
            aeInfo: deliverable.masterTemplate.aeInfo,
            computedOverwrites
        });

        return acc;
    }, []);

    return inputs;
}
